import { createGlobaleFonts } from '@lara/components'

import Inter from '../assets/inter.woff2'

export const GlobalFonts = createGlobaleFonts(Inter)
